var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhistle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.999,
    viewBox: "0 0 35 34.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whistle_1_",
    "data-name": "whistle (1)",
    d: "M11.667,17.5A5.833,5.833,0,1,0,17.5,23.332,5.833,5.833,0,0,0,11.667,17.5Zm0,8.75a2.917,2.917,0,1,1,2.917-2.917A2.917,2.917,0,0,1,11.667,26.249ZM31.353,11.666H12A11.888,11.888,0,0,0,.033,22.449,11.666,11.666,0,0,0,11.675,35a12.053,12.053,0,0,0,1.865-.146,11.6,11.6,0,0,0,8.615-6.5,11.52,11.52,0,0,0,1.177-4.795,1.458,1.458,0,0,1,1.146-1.467l7.526-1.368A3.646,3.646,0,0,0,35,17.132v-1.82a3.646,3.646,0,0,0-3.646-3.646Zm.729,5.466a.729.729,0,0,1-.6.717l-7.528,1.369A4.347,4.347,0,0,0,20.416,23.5a8.75,8.75,0,1,1-17.473-.831A8.96,8.96,0,0,1,12,14.583H31.353a.729.729,0,0,1,.729.729ZM13.125,5.833V1.458a1.458,1.458,0,1,1,2.917,0V5.833a1.458,1.458,0,1,1-2.917,0Zm5.26.806,2.187-4.375a1.459,1.459,0,1,1,2.61,1.3L21,7.943a1.458,1.458,0,1,1-2.609-1.3ZM5.99,3.577a1.458,1.458,0,1,1,2.6-1.312L10.8,6.64A1.458,1.458,0,1,1,8.2,7.952Z",
    transform: "translate(0.001)",
    fill: "#F89E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistle1);
export default __webpack_public_path__ + "static/media/whistle (1).ac3e6834219f8960db1773a03fccb611.svg";
export { ForwardRef as ReactComponent };